module.exports = __webpack_public_path__ + "static/media/weather-3.c0612793.svg";